"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncComponent = require("./asyncComponent");

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Dynamic import function for components

var styleItem = {
  flex: "1 0 30%",
  width: "33.33%",
  marginRight: "6px",
  marginLeft: "6px"
};

var HallMasterSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/HallMaster").then(function (module) {
    return module.default;
  });
});

var HallMasterAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/HallMaster/HallMasterAdd").then(function (module) {
    return module.default;
  });
});

var PUAgencyMasterSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/PUAgencyMaster").then(function (module) {
    return module.default;
  });
});

var PUAgencyMasterAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/PUAgencyMaster/PUAgencyMasterAdd").then(function (module) {
    return module.default;
  });
});

var MISCChargeMasterSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/MISCChargeMaster").then(function (module) {
    return module.default;
  });
});

var MISCChargeMasterAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/MISCChargeMaster/MISCChargeMasterAdd").then(function (module) {
    return module.default;
  });
});

var ResponsibilitySearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/Responsibility").then(function (module) {
    return module.default;
  });
});

var ResponsibilityAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/Responsibility/ResponsibilityAdd").then(function (module) {
    return module.default;
  });
});

var FixedHeadSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/FIxedHead").then(function (module) {
    return module.default;
  });
});

var FixedHeadAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/FIxedHead/FixedHeadAdd").then(function (module) {
    return module.default;
  });
});

var HallRateTypeSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/HallRateType").then(function (module) {
    return module.default;
  });
});

var HallRateTypeAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/HallRateType/HallRateTypeAdd").then(function (module) {
    return module.default;
  });
});

var SurFaceHeadSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/SurFaceHead").then(function (module) {
    return module.default;
  });
});

var SurFaceHeadAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/SurFaceHead/SurFaceHeadAdd").then(function (module) {
    return module.default;
  });
});

var SurFaceSubHeadSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/SurFaceSubHead").then(function (module) {
    return module.default;
  });
});

var SurFaceSubHeadAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/SurFaceSubHead/SurFaceSubHeadAdd").then(function (module) {
    return module.default;
  });
});

var SurFaceSpecificationSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/SurFaceSpecification").then(function (module) {
    return module.default;
  });
});

var SurFaceSpecificationAdd = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/SurFaceSpecification/SurFaceSpecificationAdd").then(function (module) {
    return module.default;
  });
});

var SubFaceHeadSubheadMap = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master/SubFaceHeadSubheadMap").then(function (module) {
    return module.default;
  });
});

var DrainageConnectionSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Drainage").then(function (module) {
    return module.default;
  });
});

var DrainageConnectionDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Drainage/DrainageDetails").then(function (module) {
    return module.default;
  });
});

var RestorationRateSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateDetails/RestorationRate").then(function (module) {
    return module.default;
  });
});
var RestorationRateUpdate = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateDetails/RestorationRate/Update").then(function (module) {
    return module.default;
  });
});
var HiringRateSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateDetails/HiringRate").then(function (module) {
    return module.default;
  });
});

var HiringRateCreate = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateDetails/HiringRate/Create").then(function (module) {
    return module.default;
  });
});

var RoadRestorationNewEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/NewEntry").then(function (module) {
    return module.default;
  });
});

var RoadRestorationIntimationSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/IntimationSearch").then(function (module) {
    return module.default;
  });
});

var RoadRestorationIntimationSearchView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/IntimationSearch/View").then(function (module) {
    return module.default;
  });
});

var RoadRestorationIntimationSearchModify = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/IntimationSearch/Modify").then(function (module) {
    return module.default;
  });
});

var RoadRestorationIntimationSearchCancel = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/IntimationSearch/Cancel").then(function (module) {
    return module.default;
  });
});

var RoadRestorationDemandSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/DemandSearch").then(function (module) {
    return module.default;
  });
});
var RoadRestorationDemandSearchView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/DemandSearch/View").then(function (module) {
    return module.default;
  });
});

var RoadRestorationDemandSearchModify = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/DemandSearch/Modify").then(function (module) {
    return module.default;
  });
});

var RoadRestorationDemandSearchCancel = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/DemandSearch/Cancel").then(function (module) {
    return module.default;
  });
});

var RoadRestorationDemandSearchExecution = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/DemandSearch/Execution").then(function (module) {
    return module.default;
  });
});

var RoadRestorationRefund = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Refund").then(function (module) {
    return module.default;
  });
});

var RoadRestorationRefundDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Refund/Details").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSearchApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SearchApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSearchApplicationView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SearchApplication/ViewDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSearchApplicationCreateIntimation = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SearchApplication/NewEntry").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSearchApplicationModifyIntimation = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SearchApplication/ModifyIntimation").then(function (module) {
    return module.default;
  });
});

var RoadRestorationCreateApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/CreateApplication").then(function (module) {
    return module.default;
  });
});

var DepartmentalDutySearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/DepartmentalDuty").then(function (module) {
    return module.default;
  });
});

var DepartmentalDutyCreate = (0, _asyncComponent2.default)(function () {
  return import("../Screens/DepartmentalDuty/Add").then(function (module) {
    return module.default;
  });
});

var DepartmentalDutyUpdate = (0, _asyncComponent2.default)(function () {
  return import("../Screens/DepartmentalDuty/Update").then(function (module) {
    return module.default;
  });
});

var BuildingNOCSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/BuildingNOC").then(function (module) {
    return module.default;
  });
});

var BuildingNOCUpload = (0, _asyncComponent2.default)(function () {
  return import("../Screens/BuildingNOC/Upload").then(function (module) {
    return module.default;
  });
});

var BuildingNOCForward = (0, _asyncComponent2.default)(function () {
  return import("../Screens/BuildingNOC/Forward").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPaymentReconciliation = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PaymentReconciliation").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPaymentSummisionSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PaymentSummision").then(function (module) {
    return module.default;
  });
});

var RoadRestorationApplicationStatus = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/ApplicationStatus").then(function (module) {
    return module.default;
  });
});

var RoadRestorationDemandGenerateKMDA = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/DemandGenerateKMDA").then(function (module) {
    return module.default;
  });
});

var RoadRestorationKPApproval = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/KPAppproval").then(function (module) {
    return module.default;
  });
});

var RoadRestorationKPApprovalView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/KPAppproval/ViewDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationROWDashboard = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Dashboard").then(function (module) {
    return module.default;
  });
});

var RoadRestorationROWDashboardView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Dashboard/View").then(function (module) {
    return module.default;
  });
});

var BuildingNOCSearchCC = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/BuildingNOC").then(function (module) {
    return module.default;
  });
});

var BuildingNOCUploadCC = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/BuildingNOC/Upload").then(function (module) {
    return module.default;
  });
});

var BuildingNOCForwardCC = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/BuildingNOC/Forward").then(function (module) {
    return module.default;
  });
});

var BuildingCaseStatusSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/BuildingCaseStatus").then(function (module) {
    return module.default;
  });
});

var BuildingCaseStatusDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/BuildingCaseStatus/Details").then(function (module) {
    return module.default;
  });
});

var PendingIFUSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/PendingIFU").then(function (module) {
    return module.default;
  });
});

var PendingIFUDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/PendingIFU/Details").then(function (module) {
    return module.default;
  });
});

var DemandGenerationSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/DemandGeneration").then(function (module) {
    return module.default;
  });
});

var DemandGenerationDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/DemandGeneration/Details").then(function (module) {
    return module.default;
  });
});

var PendingEESearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/PendingEE").then(function (module) {
    return module.default;
  });
});

var PendingEEDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CAFII/PendingEE/Details").then(function (module) {
    return module.default;
  });
});

var HallAvailability = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/HallAvailability").then(function (module) {
    return module.default;
  });
});

var HallAvailabilityDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/HallAvailability/View").then(function (module) {
    return module.default;
  });
});

// const HallBookingOffline = asyncComponent(() =>
//   import("../Screens/HallBooking/HallBookingOffline").then(
//     (module) => module.default
//   )
// );

var HallBookingOnline = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/HallBookingOnline").then(function (module) {
    return module.default;
  });
});

var HallBookingSearchApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/SearchApplication").then(function (module) {
    return module.default;
  });
});
var HallBookingSearchApplicationView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/SearchApplication/View").then(function (module) {
    return module.default;
  });
});

var HallBookingSearchApplicationDemand = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/SearchApplication/ViewDemand").then(function (module) {
    return module.default;
  });
});
var HallBookingApproveReject = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/ApproveReject").then(function (module) {
    return module.default;
  });
});
var HallBookingApproveRejectView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HallBooking/ApproveReject/View").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPaymentConfirmationKMDA = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PaymentConfirmationKMDA").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPlanedCuttingCreate = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PlannedCutting/CreateApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPlanedCuttingApplicationModify = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PlannedCutting/SearchApplication/ModifyApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPlanedCuttingSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PlannedCutting/SearchApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPlanedCuttingView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PlannedCutting/SearchApplication/ViewDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPlanedCuttingDemandDraft = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PlannedCutting/SearchApplication/NewEntry").then(function (module) {
    return module.default;
  });
});

var RoadRestorationPlanedCuttingDemandDraftModify = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/PlannedCutting/SearchApplication/ModifyIntimation").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageCreate = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/CreateApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageGenerateDemand = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/MiscDemand").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageGenerateDemandSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/MiscDemand/Search").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/SearchApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/SearchApplication/ViewDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageApplicationModify = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/SearchApplication/ViewDetails/ModifyApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageChockageRemovalStatus = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/ChockageRemovalStatus").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageChockageRemovalStatusSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/ChockageRemovalStatus/Search").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageCommunicationToDrainage = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/CommunicationToDrainage").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageCommunicationToDrainageSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/CommunicationToDrainage/Search").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockagePlumberAppointmentDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/PlumberAppointmentDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockagePlumberAppointmentDetailsSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/PlumberAppointmentDetails/Search").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockagePermissionUpload = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/PermissionUpload").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockagePermissionUploadSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/PermissionUpload/Search").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageRestorationDemand = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/FinalRestorationDemand").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageRestorationDemandSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/FinalRestorationDemand/Search").then(function (module) {
    return module.default;
  });
});

var RoadRestorationChockageCreateRestorationDemand = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/Chockage/SearchApplication/ViewDetails/NewEntry").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingCreateApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/CreateApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingSearchApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication/ViewDetails").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingModifyApplication = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication/ModifyApplication").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingDemandDraft = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/SearchApplication/NewEntry").then(function (module) {
    return module.default;
  });
});

var RoadRestorationSmallCuttingCombinedDemandGenerate = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RoadRestoration/SmallCutting/CombinedDemandGenerate").then(function (module) {
    return module.default;
  });
});

// Example route configuration
var routes = [{
  path: "egov-civil/master/HallMasterSearch",
  component: HallMasterSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/HallMasterAdd",
  component: HallMasterAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/PUAgencyMasterSearch",
  component: PUAgencyMasterSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/PUAgencyMasterAdd",
  component: PUAgencyMasterAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/MISCChargeMasterSearch",
  component: MISCChargeMasterSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/MISCChargeMasterAdd",
  component: MISCChargeMasterAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/ResponsibilitySearch",
  component: ResponsibilitySearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/ResponsibilityAdd",
  component: ResponsibilityAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/FixedHeadSearch",
  component: FixedHeadSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/FixedHeadAdd",
  component: FixedHeadAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/HallRateTypeSearch",
  component: HallRateTypeSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/HallRateTypeAdd",
  component: HallRateTypeAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/SurFaceHeadSearch",
  component: SurFaceHeadSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/SurFaceHeadAdd",
  component: SurFaceHeadAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/SurFaceSubHeadSearch",
  component: SurFaceSubHeadSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/SurFaceSubHeadAdd",
  component: SurFaceSubHeadAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/SurFaceSpecificationSearch",
  component: SurFaceSpecificationSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/master/SurFaceSpecificationAdd",
  component: SurFaceSpecificationAdd,
  needsAuthentication: true
}, {
  path: "egov-civil/master/SubFaceHeadSubheadMap",
  component: SubFaceHeadSubheadMap,
  needsAuthentication: true
}, {
  path: "egov-civil/drainage/connectionSearch",
  component: DrainageConnectionSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/drainage/connectionDetails",
  component: DrainageConnectionDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/rateDetails/restorationRateSearch",
  component: RestorationRateSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/rateDetails/restorationRateUpdate",
  component: RestorationRateUpdate,
  needsAuthentication: true
}, {
  path: "egov-civil/rateDetails/hiringRateSearch",
  component: HiringRateSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/rateDetails/hiringRateCreate",
  component: HiringRateCreate,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/newEntry",
  component: RoadRestorationNewEntry,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/intimationSearch",
  component: RoadRestorationIntimationSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/intimationSearch/view",
  component: RoadRestorationIntimationSearchView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/intimationSearch/modify",
  component: RoadRestorationIntimationSearchModify,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/intimationSearch/cancel",
  component: RoadRestorationIntimationSearchCancel,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/demandSearch",
  component: RoadRestorationDemandSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/demandSearch/view",
  component: RoadRestorationDemandSearchView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/demandSearch/modify",
  component: RoadRestorationDemandSearchModify,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/demandSearch/cancel",
  component: RoadRestorationDemandSearchCancel,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/demandSearch/execution",
  component: RoadRestorationDemandSearchExecution,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/refund",
  component: RoadRestorationRefund,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/refund/details",
  component: RoadRestorationRefundDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/searchApplication",
  component: RoadRestorationSearchApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/searchApplication/view",
  component: RoadRestorationSearchApplicationView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/searchApplication/createIntimation",
  component: RoadRestorationSearchApplicationCreateIntimation,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/searchApplication/modifyIntimation",
  component: RoadRestorationSearchApplicationModifyIntimation,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/createApplication",
  component: RoadRestorationCreateApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/departmentalDuty/search",
  component: DepartmentalDutySearch,
  needsAuthentication: true
}, {
  path: "egov-civil/departmentalDuty/create",
  component: DepartmentalDutyCreate,
  needsAuthentication: true
}, {
  path: "egov-civil/departmentalDuty/update",
  component: DepartmentalDutyUpdate,
  needsAuthentication: true
}, {
  path: "egov-civil/buildingNOC/search",
  component: BuildingNOCSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/buildingNOC/upload",
  component: BuildingNOCUpload,
  needsAuthentication: true
}, {
  path: "egov-civil/buildingNOC/forward",
  component: BuildingNOCForward,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/PaymentReconciliation",
  component: RoadRestorationPaymentReconciliation,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/KMDA/PaymentConfirmation",
  component: RoadRestorationPaymentConfirmationKMDA,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/paymentSummision",
  component: RoadRestorationPaymentSummisionSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/applicationStatus",
  component: RoadRestorationApplicationStatus,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/KMDA/demandGenerate",
  component: RoadRestorationDemandGenerateKMDA,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/kpApproval",
  component: RoadRestorationKPApproval,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/kpApproval/view",
  component: RoadRestorationKPApprovalView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/rowDashboard",
  component: RoadRestorationROWDashboard,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/rowDashboard/view",
  component: RoadRestorationROWDashboardView,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/buildingNOC/search",
  component: BuildingNOCSearchCC,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/buildingNOC/upload",
  component: BuildingNOCUploadCC,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/buildingNOC/forward",
  component: BuildingNOCForwardCC,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/buildingCaseStatus/search",
  component: BuildingCaseStatusSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/buildingCaseStatus/details",
  component: BuildingCaseStatusDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/pendingIFU/search",
  component: PendingIFUSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/pendingIFU/details",
  component: PendingIFUDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/demandGeneration/search",
  component: DemandGenerationSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/demandGeneration/details",
  component: DemandGenerationDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/pendingEE/search",
  component: PendingEESearch,
  needsAuthentication: true
}, {
  path: "egov-civil/cafII/pendingEE/details",
  component: PendingEEDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/hallBooking/hallAvailability",
  component: HallAvailability,
  needsAuthentication: true
}, {
  path: "egov-civil/hallBooking/hallAvailability/details",
  component: HallAvailabilityDetails,
  needsAuthentication: true
},
// {
//   path: "egov-civil/hallBooking/hallBookingOffline",
//   component: HallBookingOffline,
//   needsAuthentication: true,
// },
{
  path: "egov-civil/hallBooking/hallBookingOnline",
  component: HallBookingOnline,
  needsAuthentication: true
}, {
  path: "egov-civil/hallBooking/searchApplication",
  component: HallBookingSearchApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/hallBooking/searchApplication/details",
  component: HallBookingSearchApplicationView,
  needsAuthentication: true
}, {
  path: "egov-civil/hallBooking/searchApplication/demand",
  component: HallBookingSearchApplicationDemand,
  needsAuthentication: true
}, {
  path: "egov-civil/hallBooking/approveReject",
  component: HallBookingApproveReject,
  needsAuthentication: true
}, {
  path: "egov-civil/hallBooking/approveReject/details",
  component: HallBookingApproveRejectView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/planedCutting/create",
  component: RoadRestorationPlanedCuttingCreate,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/planedCutting/application/modify",
  component: RoadRestorationPlanedCuttingApplicationModify,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/planedCutting/search",
  component: RoadRestorationPlanedCuttingSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/planedCutting/view",
  component: RoadRestorationPlanedCuttingView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/planedCutting/demandDraft",
  component: RoadRestorationPlanedCuttingDemandDraft,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/planedCutting/demandDraftModify",
  component: RoadRestorationPlanedCuttingDemandDraftModify,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/create",
  component: RoadRestorationChockageCreate,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/generateDemand",
  component: RoadRestorationChockageGenerateDemand,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/generateDemand/search",
  component: RoadRestorationChockageGenerateDemandSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/search",
  component: RoadRestorationChockageSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/view",
  component: RoadRestorationChockageView,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/application/modify",
  component: RoadRestorationChockageApplicationModify,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/chockageRemovalStatus",
  component: RoadRestorationChockageChockageRemovalStatus,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/chockageRemovalStatus/search",
  component: RoadRestorationChockageChockageRemovalStatusSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/communicationToDrainage",
  component: RoadRestorationChockageCommunicationToDrainage,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/communicationToDrainage/search",
  component: RoadRestorationChockageCommunicationToDrainageSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/plumberAppointmentDetails",
  component: RoadRestorationChockagePlumberAppointmentDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/plumberAppointmentDetails/search",
  component: RoadRestorationChockagePlumberAppointmentDetailsSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/permissionUpload",
  component: RoadRestorationChockagePermissionUpload,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/permissionUpload/search",
  component: RoadRestorationChockagePermissionUploadSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/restorationDemand",
  component: RoadRestorationChockageRestorationDemand,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/restorationDemand/search",
  component: RoadRestorationChockageRestorationDemandSearch,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/chockage/createRestorationDemand",
  component: RoadRestorationChockageCreateRestorationDemand,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/smallCutting/createApplication",
  component: RoadRestorationSmallCuttingCreateApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/smallCutting/searchApplication",
  component: RoadRestorationSmallCuttingSearchApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/smallCutting/view",
  component: RoadRestorationSmallCuttingDetails,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/smallCutting/modifyApplication",
  component: RoadRestorationSmallCuttingModifyApplication,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/smallCutting/demandDraft",
  component: RoadRestorationSmallCuttingDemandDraft,
  needsAuthentication: true
}, {
  path: "egov-civil/roadRestoration/smallCutting/combinedDemandGenerate",
  component: RoadRestorationSmallCuttingCombinedDemandGenerate,
  needsAuthentication: true
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-civil/Routes/module-routes.js
// module id = 3528
// module chunks = 1137